<template>
  <div>
    <h2>Search</h2>
    <v-alert
      :value="true"
      type="info"
    >Search using the filter boxes at the top of the columns. Sort by clicking the column name. Click a button to go to the record.</v-alert>
    <v-expansion-panel v-model="panel" expand>
      <v-expansion-panel-content>
        <template v-slot:header>
          <h2>
            <v-icon>search</v-icon>Filter Records
          </h2>
        </template>
        <v-card>
          <v-card-text>
            <v-container fluid grid-list-md>
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-text-field v-model="filters.id" label="Id" outline />
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field v-model="filters.fileid" label="File id" outline />
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field v-model="filters.freereference" label="Free reference" outline />
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field v-model="filters.bankname" label="Bank name" outline />
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field v-model="filters.sortcode" label="Sortcode" outline />
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field v-model="filters.bankacno" label="Bank ac no" outline />
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field v-model="filters.beneficiary" label="Beneficiary" outline />
                </v-flex>
              </v-layout>
            </v-container>
            <v-btn @click="searchFilters" :loading="loading">
              <v-icon>search</v-icon>
              <span>&#160;Search</span>
            </v-btn>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-data-table
      :pagination.sync="pagination"
      :total-items="paymentsCount"
      :loading="loading"
      :headers="headers"
      :items="computedPayments"
      :footer-props="{ showFirstLastPage, showCurrentPage }"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <v-btn :to="{name:'payment', params:{id:props.item.id}}" small>{{ props.item.id }}</v-btn>
          </td>
          <td>
            <FileZ :file="props.item.file" v-if="props.item.file" />
            <span v-if="!props.item.file">{{props.item.freereference}}</span>
          </td>
          <td>{{ props.item.bankname }}</td>
          <td>{{ props.item.sortcode }}</td>
          <td>{{ props.item.bankacno }}</td>
          <td>{{ props.item.beneficiary }}</td>
          <td style="text-align:right;">{{ props.item.amount | toCurrency }}</td>
          <td>{{ props.item.timesent }}</td>
          <td>{{ props.item.timestamp | formatDateTime }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "PaymentsNotAutolaw",
  metaInfo() {
    return {
      title: "Payments not autolaw",
      titleTemplate: "%s - Fundview - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  computed: {
    firstRow() {
      const { page, rowsPerPage } = this.pagination;
      return (page - 1) * rowsPerPage;
    },
    computedPayments() {
      if (!this.payments) {
        return undefined;
      }
      return this.payments.map(q => {
        const file = this.files ? this.files[q.id] : undefined;
        return {
          ...q,
          file
        };
      });
    }
  },
  data() {
    return {
      paymentsCount: 0,
      payments: [],
      files: null,
      filters: {
        id: null,
        fileid: null,
        freereference: null,
        bankname: null,
        sortcode: null,
        bankacno: null,
        beneficiary: null
      },
      loading: false,
      headers: [
        {
          text: "Id",
          value: "id"
        },
        {
          text: "File",
          value: "file.referencelong"
        },
        {
          text: "Bank",
          value: "bankname"
        },
        {
          text: "Sort",
          value: "sortcode"
        },
        {
          text: "A/c",
          value: "bankacno"
        },
        {
          text: "Beneficiary",
          value: "beneficiary"
        },
        {
          text: "Amount",
          value: "amount",
          align: "right"
        },
        {
          text: "Sent",
          value: "timesent"
        },
        {
          text: "Date",
          value: "timestamp"
        }
      ],
      pagination: {
        page: 1,
        rowsPerPage: 10,
        sortBy: "timestamp",
        descending: true
      },
      showFirstLastPage: true,
      showCurrentPage: true,
      panel: []
    };
  },
  methods: {
    fetchPayments(rowsPerPage) {
      nbmlaw
        .post(
          `/cors/admin/fundview/payments/search/notautolaw/${this.firstRow}/${rowsPerPage}`,
          this.filters
        )
        .then(response => {
          // console.log(response.data);
          this.payments = response.data;
          this.loading = false;
        });
    },
    fetchPaymentsCount() {
      nbmlaw
        .post(
          `/cors/admin/fundview/payments/search/notautolaw/count`,
          this.filters
        )
        .then(response => {
          // console.log(response.data)
          this.paymentsCount = response.data;
        });
    },
    fetchFiles(rowsPerPage) {
      nbmlaw
        .post(
          `/cors/admin/fundview/payments/search/notautolaw/${this.firstRow}/${rowsPerPage}/files`,
          this.filters
        )
        .then(response => {
          // console.log(response.data);
          this.files = response.data;
        });
    },
    update() {
      this.loading = true;
      const { sortBy, descending, rowsPerPage } = this.pagination;
      if (rowsPerPage != -1) {
        this.filters.sortBy = sortBy;
        this.filters.descending = descending;
        this.fetchPaymentsCount();
        this.fetchPayments(rowsPerPage);
        this.fetchFiles(rowsPerPage);
      } else {
        this.pagination.rowsPerPage = 10;
      }
    },
    searchFilters() {
      this.pagination.page = 1;
      this.update();
    }
  },
  watch: {
    pagination: {
      handler() {
        this.update();
      },
      deep: true
    }
  },
  created() {
    this.update();
  }
};
</script>